import { cn } from '@core/utils';

import { CustomLink } from '@/app/_components/CustomLink';

interface LinkableBoxProps {
  href?: string;
  children: React.ReactNode;
  className?: string;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
  as?: React.ElementType;
}

export const LinkableBox = ({
  href,
  className,
  as: Component = 'div',
  ...restProps
}: LinkableBoxProps) => {
  if (href && href !== '#')
    return (
      <CustomLink
        {...restProps}
        className={cn('text-Gray-900 no-underline', className)}
        href={href}
      />
    );

  return <Component {...restProps} className={className} />;
};
